import User from '@/dto/User'

class StorageHelper {
  static storageKey = 'logged_users'

  users: { [key: string]: User } = {}

  constructor() {
    const storageData = localStorage.getItem(StorageHelper.storageKey)

    if (storageData) {
      this.users = JSON.parse(storageData)
    }
  }

  saveUser(user: User) {
    this.users[user.phone] = user
    localStorage.setItem(StorageHelper.storageKey, JSON.stringify(this.users))
  }

  getUserByPhone(phone: string): User | null {
    return this.users[phone] || null
  }
}

export default new StorageHelper()
